export default "__VITE_ASSET__DZVbV19S__"